<template>
  <div class="totalBox">
    <div class="top">
      <div class="left">
        <img class="image" :src="props.image" />
        <span>{{ props.name }}</span>
      </div>
      <span>{{ total }}</span>
    </div>
    <Line />
    <div class="bottom">
      <div v-for="(item, i) in listData" :key="i" class="item">
        <span class="name">{{ item.name }}</span>
        <span class="value">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Line from '@core/components/line.vue'
import { ref, watch } from 'vue'
const props = defineProps({
  list: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  },
  name: {
    // 下拉区域始终为全屏的高度
    type: String,
    default: ''
  },
  image: {
    // 下拉区域始终为全屏的高度
    type: String,
    default: ''
  },
  total: {
    type: String,
    default: '0'
  }
})
const listData = ref(props.list)
const total = ref(props.total)
watch(
  () => props.list,
  (value) => {
    listData.value = value
  }
)
watch(
  () => props.total,
  (value) => {
    total.value = value
  }
)
</script>

<style scoped lang="less">
.totalBox {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px 0;
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 16px;
    padding-bottom: 15px;
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      color: #3c3c3c;
      .image {
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    padding: 0 16px;
    .item {
      display: flex;
      flex-direction: column;
      flex: 3;
      align-items: center;
      justify-content: center;
      .name {
        color: #6e6e6e;
        font-size: 11px;
        margin-bottom: 8px;
      }
      .value {
        color: #3c3c3c;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
